/**
* 祝日
*/
import axios from '@/plugins/axios';

const actions = {
  /** ページ情報のセット */
  setHoliday({ commit }) {
    axios({
      method: 'GET',
      url: '/v1/holiday/get/list',
    })
      .then((response) => {
        const holiday = response.data.data;
        commit('setHoliday', holiday);
      })
      .catch((error) => {
        if (error.response) console.log(error.response.data);
        else console.log(error);
      });
  },
};

const mutations = {
  setHoliday(state, data) {
    state.list = data;
  },
};

const state = {
  list: [],
};

export default {
  namespaced: true,
  actions,
  mutations,
  state,
};
